import { ArrowRight, Layers } from "lucide-react";
import { euros } from "@/lib/ceda";

export const PackComposer = ({ mode, setMode, sameFamily, setSameFamily, selected, size, prices, onBuy, onClear }) => (
  <div className="rounded-3xl bg-[#1F2A24] text-[#F6F2E9] p-6 md:p-8" data-testid="ceda-composer">
    <div className="flex flex-wrap items-center gap-2">
      {[["single", "À l'unité", prices.ceda_single], ["3", "Pack de 3", prices.ceda_pack3], ["7", "Pack de 7", prices.ceda_pack7]].map(([k, label, p]) => (
        <button
          key={k}
          data-testid={`ceda-mode-${k}`}
          onClick={() => setMode(k)}
          className={`rounded-full px-5 py-2.5 font-ui text-sm transition-colors ${mode === k ? "bg-[#C9A24B] text-[#1F2A24]" : "border border-[#F6F2E9]/25 hover:border-[#C9A24B]"}`}
        >
          {label} · {euros(p)}
        </button>
      ))}
    </div>
    {mode !== "single" && (
      <div className="mt-6 flex flex-wrap items-center justify-between gap-5">
        <div>
          <p className="font-serif text-2xl inline-flex items-center gap-2"><Layers size={20} className="text-[#C9A24B]" /> {selected.length} / {size} capsules choisies</p>
          <label className="mt-2 flex items-center gap-2 font-sans text-sm text-[#F6F2E9]/75 cursor-pointer">
            <input type="checkbox" data-testid="ceda-same-family" checked={sameFamily} onChange={(e) => setSameFamily(e.target.checked)} className="accent-[#C9A24B]" />
            Composer dans une seule famille
          </label>
        </div>
        <div className="flex items-center gap-3">
          {selected.length > 0 && <button onClick={onClear} className="font-sans text-sm text-[#F6F2E9]/60 hover:text-white" data-testid="ceda-composer-clear">Vider</button>}
          <button
            data-testid="ceda-composer-buy"
            disabled={selected.length !== size}
            onClick={onBuy}
            className="inline-flex items-center gap-2 rounded-full bg-[#C9A24B] text-[#1F2A24] px-6 py-3 font-ui text-sm hover:bg-[#b8923f] disabled:opacity-40 transition-colors"
          >
            Obtenir mon pack <ArrowRight size={16} />
          </button>
        </div>
      </div>
    )}
  </div>
);
